<template lang="pug">
  v-container.layout(fluid)
    v-layout(column wrap align-center justify-center)
      v-progress-circular(
        :size='80'
        :width='8'
        color='primary'
        indeterminate
      )
      span Connecting your Google account...
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  data() {
    return {
      code: '',
    };
  },
  async mounted() {
    const featureIds = JSON.parse(localStorage.getItem('googleFeatureIds'));
    const googleScopesToBeGranted = JSON.parse(
      localStorage.getItem('googleScopesToBeGranted'),
    ).split(' ');
    localStorage.removeItem('googleFeatureIds');
    localStorage.removeItem('googleScopesToBeGranted');

    try {
      const listOfPermissionsGranted = this.$route.query.scope.split(' ');
      console.log(listOfPermissionsGranted);
      if (!this.areAllPermissionsGranted(googleScopesToBeGranted, listOfPermissionsGranted)) {
        localStorage.setItem('allPermissionsWereGranted', false);
        return;
      }

      localStorage.setItem('allPermissionsWereGranted', true);
      const { code, state } = this.$route.query;
      await this.connectGmailToNylas({
        code,
        state,
        feature_ids: featureIds,
      });
      await this.callUpdateFeatureFlag({ flag: 'nylas-ms-reauth', active: false });
      return;
    } catch (e) {
      console.log(e);
    } finally {
      window.close();
    }
  },
  computed: {
    ...mapState({
      exchanceConnectionScopes: state => state.emailManagement.exchanceConnectionScopes,
    }),
  },
  methods: {
    ...mapActions('emailManagement', ['connectGmailToNylas']),
    ...mapActions('ldAppLayout', ['callUpdateFeatureFlag']),
    areAllPermissionsGranted(permissionsNeeded, permissionsGranted) {
      return permissionsNeeded.every(x => permissionsGranted.includes(x));
    },
  },
};
</script>